import * as React from "react";

import Backdrop from "../backdrop/Backdrop";

type ModalProps = {
  show: any;
  children?: React.ReactNode;
};

const Modal: React.FC<ModalProps> = (props) => {
  const { show } = props;
  return show ? (
    <React.Fragment>
      <Backdrop show={show} />
      <div
        className="modal"
        style={{
          transform: show ? "translateY(0)" : "translateY(-100vh)",
          opacity: show ? 1 : 0,
        }}
      >
        {props.children}
      </div>
    </React.Fragment>
  ) : null;
};

export default Modal;
